/* eslint-disable react/button-has-type */
import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import * as css from './Button.scss';

export default class Button extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		color: PropTypes.oneOf([Button.TRANSPARENT, Button.PRIMARY]),
		outherBorder: PropTypes.bool,
		disabled: PropTypes.bool,
		children: PropTypes.node,
		type: PropTypes.string,
		size: PropTypes.oneOf([Button.DEFAULT, Button.SMALL]),
		label: PropTypes.string.isRequired,
		onClick: PropTypes.func,
		absoluteInner: PropTypes.bool,
	};

	static defaultProps = {
		className: '',
		children: null,
		size: Button.DEFAULT,
		color: Button.TRANSPARENT,
		outherBorder: true,
		type: 'button',
		disabled: false,
		absoluteInner: false,
		onClick: _.noop(),
	};

	get classNames() {
		const { color, size, outherBorder, disabled } = this.props;

		return {
			[css[color]]: true,
			[css.outherBorder]: outherBorder,
			[css[size]]: true,
			[css.disabled]: disabled,
		};
	}

	static TRANSPARENT = 'transparent';

	static PRIMARY = 'primary';

	static DEFAULT = '';

	static SMALL = 'small';

	render() {
		const { className, ...rest } = this.props;

		return (
			<button
				className={classNames(
					css.button,
					this.classNames,
					this.props.absoluteInner && css.absoluteLabel,
					className
				)}
				onClick={this.props.onClick}
				{..._.omit(rest, ['solid', 'color', 'children', 'outherBorder', 'absoluteInner', 'disabled'])}
			>
				<div className={css.buttonInner}>
					<p className={css.label}>{this.props.label}</p>
				</div>
			</button>
		);
	}
}
